import categoryPageCartImage from "../../assets/images/category-page-card.png";
import vitaminsSupplmentsPromoImage from "../../assets/images/vitamins-supplements-promo.jpg";
export var Tag;
!function (t) {
  t.General = "general", t.NutritionalHealth = "nutritional-digestive-health", t.VitaminsAndSupplements = "vitamins-and-supplements", t.Men = "men", t.Women = "women", t.SexualHealth = "sexual-health", t.COVID = "covid", t.None = "";
}(Tag || (Tag = {}));
export var productLinksMap = {
  "food-sensitivity-test": {
    slug: "food-sensitivity-test",
    label: "Food Sensitivity Test",
    url: "/products/food-sensitivity/",
    tags: [Tag.NutritionalHealth]
  },
  "food-sensitivity-comprehensive-test": {
    slug: "food-sensitivity-comprehensive-test",
    label: "Food Sensitivity Comprehensive Test",
    url: "/products/food-sensitivity-comprehensive-test/",
    tags: [Tag.NutritionalHealth]
  },
  "metabolism-test": {
    slug: "metabolism-test",
    label: "Metabolism Test",
    url: "/products/metabolism/",
    tags: [Tag.NutritionalHealth]
  },
  "food-allergy-test": {
    slug: "food-allergy-test",
    label: "Food Allergy Test",
    url: "/products/food-allergy-test/",
    tags: [Tag.NutritionalHealth],
    badge: "New"
  },
  "celiac-disease-screening-test": {
    slug: "celiac-disease-screening-test",
    label: "Celiac Disease Screening Test",
    url: "/products/celiac-disease-screening-test/",
    tags: [Tag.NutritionalHealth],
    badge: "New"
  },
  "vitamin-d-and-inflammation-test": {
    slug: "vitamin-d-and-inflammation-test",
    label: "Vitamin D and Inflammation Test",
    url: "/products/vitamin-d-and-inflammation-test/",
    tags: [Tag.NutritionalHealth]
  },
  "vitamin-d-test": {
    slug: "vitamin-d-test",
    label: "Vitamin D Test",
    url: "/products/vitamin-d-test/",
    tags: [Tag.NutritionalHealth]
  },
  "thyroid-test": {
    slug: "thyroid-test",
    label: "Thyroid Test",
    url: "/products/thyroid-test/",
    tags: [Tag.General]
  },
  "cholesterol-and-lipids-test": {
    slug: "cholesterol-and-lipids-test",
    label: "Cholesterol and Lipids Test",
    url: "/products/cholesterol-and-lipids-test/",
    tags: [Tag.General]
  },
  "hba1c-test": {
    slug: "hba1c-test",
    label: "HbA1c Test",
    url: "/products/hba1c/",
    tags: [Tag.General]
  },
  "indoor-outdoor-allergy-test": {
    slug: "indoor-outdoor-allergy-test",
    label: "Indoor & Outdoor Allergy Test",
    url: "/products/indoor-outdoor-allergy-test/",
    tags: [Tag.General]
  },
  "fit-colon-cancer-screening-test": {
    slug: "fit-colon-cancer-screening-test",
    label: "FIT Colon Cancer Screening Test",
    url: "/products/fit-colon-cancer-screening-test/",
    tags: [Tag.General]
  },
  "heart-health-test": {
    slug: "heart-health-test",
    label: "Heart Health Test",
    url: "/products/heart-health-test/",
    tags: [Tag.General]
  },
  "sleep-and-stress-panel": {
    slug: "sleep-and-stress-panel",
    label: "Sleep and Stress Test",
    url: "/products/sleep-and-stress-panel/",
    tags: [Tag.General]
  },
  "lyme-disease-test": {
    slug: "lyme-disease-test",
    label: "Lyme Disease Test",
    url: "/products/lyme-disease-test/",
    tags: [Tag.General]
  },
  "elements-panel": {
    slug: "elements-panel",
    label: "Heavy Metals Test",
    url: "/products/elements-panel/",
    tags: [Tag.General]
  },
  "std-test-female": {
    slug: "std-test-female",
    label: "STD Test - Female",
    url: "/products/std-test-female/",
    tags: [Tag.SexualHealth]
  },
  "std-test-male": {
    slug: "std-test-male",
    label: "STD Test - Male",
    url: "/products/std-test-male/",
    tags: [Tag.SexualHealth]
  },
  "chlamydia-gonorrhea-test": {
    slug: "chlamydia-gonorrhea-test",
    label: "Chlamydia and Gonorrhea Test",
    url: "/products/chlamydia-gonorrhea-test/",
    tags: [Tag.SexualHealth]
  },
  "hpv-test-female": {
    slug: "hpv-test-female",
    label: "HPV Test - Female",
    url: "/products/hpv-test-female/",
    tags: [Tag.SexualHealth]
  },
  "trichomoniasis-test": {
    slug: "trichomoniasis-test",
    label: "Trichomoniasis Test",
    url: "/products/trichomoniasis-test/",
    tags: [Tag.SexualHealth]
  },
  "hiv-test": {
    slug: "hiv-test",
    label: "HIV Test",
    url: "/products/hiv-test/",
    tags: [Tag.SexualHealth]
  },
  "syphilis-test": {
    slug: "syphilis-test",
    label: "Syphilis Test",
    url: "/products/syphilis-test/",
    tags: [Tag.SexualHealth]
  },
  "hepatitis-c-test": {
    slug: "hepatitis-c-test",
    label: "Hepatitis C Test",
    url: "/products/hepatitis-c-test/",
    tags: [Tag.SexualHealth]
  },
  "womens-health-test": {
    slug: "womens-health-test",
    label: "Women's Health Test",
    url: "/products/womens-health-test/",
    tags: [Tag.Women]
  },
  "womens-fertility-test": {
    slug: "womens-fertility-test",
    label: "Women's Fertility Test",
    url: "/products/womens-fertility-test/",
    tags: [Tag.Women]
  },
  "perimenopause-test": {
    slug: "perimenopause-test",
    label: "Perimenopause Test",
    url: "/products/perimenopause-test/",
    tags: [Tag.Women]
  },
  "ovarian-reserve-test": {
    slug: "ovarian-reserve-test",
    label: "Ovarian Reserve Test",
    url: "/products/ovarian-reserve-test/",
    tags: [Tag.Women]
  },
  "postmenopause-test": {
    slug: "postmenopause-test",
    label: "Postmenopause Test",
    url: "/products/postmenopause-test/",
    tags: [Tag.Women]
  },
  "mens-health-test": {
    slug: "mens-health-test",
    label: "Men's Health Test",
    url: "/products/mens-health-test/",
    tags: [Tag.Men]
  },
  "testosterone-test": {
    slug: "testosterone-test",
    label: "Testosterone Test",
    url: "/products/testosterone-test/",
    tags: [Tag.Men]
  },
  "multivitamin-gummy": {
    slug: "multivitamin-gummy",
    label: "Multivitamin Gummy",
    url: "/products/multivitamin-gummy",
    tags: [Tag.NutritionalHealth, Tag.VitaminsAndSupplements],
    badge: "New"
  },
  "omega-3-fish-oil-1000-mg": {
    slug: "omega-3-fish-oil-1000-mg",
    label: "Omega-3 Fish Oil",
    url: "/products/omega-3-fish-oil-1000-mg/",
    tags: [Tag.NutritionalHealth, Tag.VitaminsAndSupplements]
  },
  "vitamin-d3-2000-iu": {
    slug: "vitamin-d3-2000-iu",
    label: "Vitamin D3",
    url: "/products/vitamin-d3-2000-iu/",
    tags: [Tag.NutritionalHealth, Tag.VitaminsAndSupplements]
  },
  "vitamin-b12-500-mcg": {
    slug: "vitamin-b12-500-mcg",
    label: "Vitamin B12",
    url: "/products/vitamin-b12-500-mcg/",
    tags: [Tag.NutritionalHealth, Tag.VitaminsAndSupplements]
  },
  "vitamin-b6-50-mg": {
    slug: "vitamin-b6-50-mg",
    label: "Vitamin B6",
    url: "/products/vitamin-b6-50-mg/",
    tags: [Tag.NutritionalHealth, Tag.VitaminsAndSupplements]
  },
  "covid-19-test": {
    slug: "covid-19-test",
    label: "COVID-19 Test Home Collection Kit DTC",
    url: "/products/covid-19-test/",
    tags: [Tag.COVID]
  },
  "business-covid-19": {
    slug: "business-covid-19",
    label: "COVID Testing for Qualifying Organizations",
    url: "/business/covid-19",
    tags: [Tag.COVID]
  }
};
export var enterpriseHardCodedHeaderContent = {
  productCategories: [{
    displayName: "Nutritional Health",
    slug: Tag.NutritionalHealth,
    badge: "New",
    productLinks: {
      Tests: [productLinksMap["food-sensitivity-test"], productLinksMap["food-sensitivity-comprehensive-test"], productLinksMap["metabolism-test"], productLinksMap["food-allergy-test"], productLinksMap["celiac-disease-screening-test"], productLinksMap["vitamin-d-and-inflammation-test"], productLinksMap["vitamin-d-test"]],
      "Vitamins & Supplements": [productLinksMap["multivitamin-gummy"], productLinksMap["omega-3-fish-oil-1000-mg"], productLinksMap["vitamin-d3-2000-iu"], productLinksMap["vitamin-b12-500-mcg"], productLinksMap["vitamin-b6-50-mg"]]
    },
    card: {
      slug: "nutritional-digestive-health",
      label: "",
      url: "/category/nutritional-digestive-health",
      tags: [Tag.NutritionalHealth],
      description: "Want to dive deeper and learn about our nutritional and digestive health essentials?",
      image: {
        alt: "Nutritional Health Category Page",
        src: categoryPageCartImage
      },
      cta: "Explore more"
    },
    filteredPipLink: {
      categoryName: "Nutritional Health",
      url: "/products/?category=13"
    }
  }, {
    displayName: "General Wellness",
    slug: Tag.General,
    productLinks: [productLinksMap["thyroid-test"], productLinksMap["cholesterol-and-lipids-test"], productLinksMap["hba1c-test"], productLinksMap["indoor-outdoor-allergy-test"], productLinksMap["fit-colon-cancer-screening-test"], productLinksMap["heart-health-test"], productLinksMap["sleep-and-stress-panel"], productLinksMap["lyme-disease-test"], productLinksMap["elements-panel"]],
    filteredPipLink: {
      categoryName: "General Wellness",
      url: "/products/?category=3"
    }
  }, {
    displayName: "Sexual Health",
    slug: Tag.SexualHealth,
    productLinks: [productLinksMap["std-test-female"], productLinksMap["std-test-male"], productLinksMap["chlamydia-gonorrhea-test"], productLinksMap["hpv-test-female"], productLinksMap["trichomoniasis-test"], productLinksMap["hiv-test"], productLinksMap["syphilis-test"], productLinksMap["hepatitis-c-test"]],
    filteredPipLink: {
      categoryName: "Sexual Health",
      url: "/products/?category=8"
    }
  }, {
    displayName: "Women's Health",
    slug: Tag.Women,
    productLinks: [productLinksMap["womens-health-test"], productLinksMap["womens-fertility-test"], productLinksMap["perimenopause-test"], productLinksMap["ovarian-reserve-test"], productLinksMap["postmenopause-test"]],
    filteredPipLink: {
      categoryName: "Women's Health",
      url: "/products/?category=6"
    }
  }, {
    displayName: "Men's Health",
    slug: Tag.Men,
    productLinks: [productLinksMap["mens-health-test"], productLinksMap["testosterone-test"]],
    filteredPipLink: {
      categoryName: "Men's Health",
      url: "/products/?category=5"
    }
  }, {
    displayName: "Vitamins & Supplements",
    slug: Tag.VitaminsAndSupplements,
    productLinks: [productLinksMap["multivitamin-gummy"], productLinksMap["omega-3-fish-oil-1000-mg"], productLinksMap["vitamin-d3-2000-iu"], productLinksMap["vitamin-b12-500-mcg"], productLinksMap["vitamin-b6-50-mg"]],
    filteredPipLink: {
      categoryName: "Vitamins & Supplements",
      url: "/products/?category=11"
    }
  }, {
    displayName: "COVID-19",
    slug: Tag.COVID,
    productLinks: [productLinksMap["covid-19-test"], productLinksMap["business-covid-19"]],
    filteredPipLink: {
      categoryName: "COVID",
      url: "/products/?category=9"
    }
  }],
  mainPromo: {
    headline: "Vitamins & Supplements",
    "data-analytics-event": "Clicked Button",
    "data-analytics-label": "navigation-promo-vitamins-and-supplements",
    slug: Tag.VitaminsAndSupplements,
    label: "Clean, simple, and backed by science. Smarter formulas you can trust.",
    url: "/products?category=11",
    tags: [],
    image: {
      alt: "Vitamins and Supplements Image",
      src: vitaminsSupplmentsPromoImage
    }
  }
};
export var promoCards = function promoCards(t) {
  return [];
};